module.exports = __webpack_public_path__ + "img/full-stack-developer.113d05a2.png";